/* eslint-disable react/jsx-handler-names */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState, useEffect } from 'react';

import classNames from 'classnames';

import classes from './styles.module.scss';

export default function MenuItem({
  disabled,
  onClick,
  icon,
  iconStyle,
  label,
  subMenu,
  menuRef,
  leftPosition,
  isMenuVisible,
  forceEnable,
}) {
  const [isSubmenuVisible, setIsSubmenuVisible] = useState(false);
  const [isEnoughSpaceForSubmenu, setIsEnoughSpaceForSubmenu] = useState(true);

  const showRecordSubmenu = () => {
    setIsSubmenuVisible(true);
  };

  const hideRecordSubmenu = () => {
    setIsSubmenuVisible(false);
  };

  // On menu render check if there is enough space for submenu
  useEffect(() => {
    if (!menuRef.current) {
      return;
    }

    const menuCoords = menuRef.current.getBoundingClientRect();

    if (menuCoords.left < 242) {
      setIsEnoughSpaceForSubmenu(false);
    } else {
      setIsEnoughSpaceForSubmenu(true);
    }
  }, [isMenuVisible, leftPosition, menuRef]);

  const hasSubMenu = subMenu && subMenu.length > 0;

  const isDisabled = !!disabled && !forceEnable;

  return (
    <li
      className={classNames(classes.MenuItem, {
        [classes.disabled]: isDisabled,
      })}
      onMouseEnter={hasSubMenu ? showRecordSubmenu : undefined}
      onMouseLeave={hasSubMenu ? hideRecordSubmenu : undefined}
      onClick={() => {
        if (isDisabled) {
          return;
        }

        onClick?.();
      }}
    >
      <span className={classes.iconContainer}>
        <img src={icon} alt={label} style={iconStyle} />
      </span>
      <div className={classes.nameContainer}>
        {label}
        {hasSubMenu && isSubmenuVisible && (
          <div
            className={classNames(classes.subMenu, {
              [classes.right]: !isEnoughSpaceForSubmenu,
            })}
            onMouseEnter={showRecordSubmenu}
            onMouseLeave={hideRecordSubmenu}
          >
            <ul>
              {subMenu.map((item) => {
                return (
                  <MenuItem
                    key={item.label}
                    disabled={item.disabled}
                    forceEnable={item.forceEnable}
                    onClick={item.onClick}
                    icon={item.icon}
                    iconStyle={item.iconStyle}
                    label={item.label}
                    subMenu={item.subMenu}
                    menuRef={menuRef}
                    leftPosition={leftPosition}
                    isMenuVisible={isMenuVisible}
                  />
                );
              })}
            </ul>
          </div>
        )}
      </div>
    </li>
  );
}
